export function dadosCarteira(dados) {
  return {
    type: 'SUMMARY',
    payload: dados,
  };
}
